import { OrderedMap } from 'immutable';
import HomeworkContent from './model';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'lessonNumber':
      return [key, Number.parseInt(val, 10)];
    case 'unitId':
      return [key, `${val}`];
    case 'contentItems':
      return [key, val.reduce((map, item) =>
        map.set(`${item.homeworkContentId}`, HomeworkContent.Item.create(item)), new OrderedMap())];
    default:
      return [key, val];
  }
};

const create = (data) =>
  new HomeworkContent(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/Homework/Content/create.js